import React from "react";
import { MONTHLY_IDS, rupees } from "../../../lib/auditMath";

export const AuditSummary = ({ calculation }) => {
  const total = calculation.grand;
  return <section className="audit-totals" data-testid="audit-totals" aria-label="Audit totals">
    <div className="audit-total" data-testid="audit-total-gaps">
      <span>Total gaps</span>
      <strong className="audit-total-count">{total.count}<small> / {MONTHLY_IDS.length}</small></strong>
    </div>
    <div className="audit-total" data-testid="audit-total-cost">
      <span>Total of what it costs me</span>
      <strong className="audit-total-red">{rupees(total.cost)}<small> /month</small></strong>
      <em>{rupees(total.cost * 12)} /year</em>
    </div>
    <div className="audit-total" data-testid="audit-total-growth">
      <span>Total growth it unlocks</span>
      <strong className="audit-total-green">{rupees(total.growth)}<small> /month</small></strong>
      <em>{rupees(total.growth * 12)} /year</em>
    </div>
  </section>;
};
